export class TextNewlineLengthUseCase {
  public execute(text: string): number {
    // when user type \n we need add more 150 caracteres
    const newLineCount = (text.match(/\n/g) || []).length * 100

    return newLineCount + text.length
  }
}
